export default __webpack_public_path__ + "static/media/image.mcqpapers-com.878c95e7.png";